import type { ChartComponentSpec } from "../Processing/types";
import type { DuplicationHandler } from "../widgetContract";

export const chartDuplicate: DuplicationHandler<ChartComponentSpec> = (spec) => {
  const idMap = new Map<string, string>();
  for (const s of spec.series) {
    const q = crypto.randomUUID();
    idMap.set(s.queryId, q);
    s.queryId = q;
  }
  for (const s of spec.series) {
    if (s.stackOn) s.stackOn = idMap.get(s.stackOn) ?? s.stackOn;
    if (s.series_builder_misc?.parentQueryId) {
      s.series_builder_misc.parentQueryId =
        idMap.get(s.series_builder_misc.parentQueryId) ?? s.series_builder_misc.parentQueryId;
    }
  }
  // Keep the "sort by this series" reference pointing at the renamed series.
  const sortRef = spec.widgetMutations.sortConfig;
  if (sortRef?.sortSeriesQueryId) {
    sortRef.sortSeriesQueryId = idMap.get(sortRef.sortSeriesQueryId) ?? sortRef.sortSeriesQueryId;
  }
};
